"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeighbourhoodItemType = void 0;
var NeighbourhoodItemType;
(function (NeighbourhoodItemType) {
    NeighbourhoodItemType[NeighbourhoodItemType["ATM"] = 0] = "ATM";
    NeighbourhoodItemType[NeighbourhoodItemType["SCHOOL"] = 1] = "SCHOOL";
    NeighbourhoodItemType[NeighbourhoodItemType["PHARMACY"] = 2] = "PHARMACY";
    NeighbourhoodItemType[NeighbourhoodItemType["BUS_STATION"] = 3] = "BUS_STATION";
    NeighbourhoodItemType[NeighbourhoodItemType["SUBWAY_STATION"] = 4] = "SUBWAY_STATION";
    NeighbourhoodItemType[NeighbourhoodItemType["CONVENIENCE_STORE"] = 5] = "CONVENIENCE_STORE";
    NeighbourhoodItemType[NeighbourhoodItemType["CAFE"] = 6] = "CAFE";
    NeighbourhoodItemType[NeighbourhoodItemType["PARK"] = 7] = "PARK";
    NeighbourhoodItemType[NeighbourhoodItemType["PIN"] = 8] = "PIN";
})(NeighbourhoodItemType = exports.NeighbourhoodItemType || (exports.NeighbourhoodItemType = {}));
